"use client";

import { FC } from "react";
import ImageGallery from "components/organisms/ImageGallery";
import { SubTitle } from "utils/styling/typography.styled";
import * as Styled from "./GalleryLanding.styled";
export const GalleryLanding: FC = () => {
  return <Styled.Main suppressHydrationWarning data-sentry-element="unknown" data-sentry-component="GalleryLanding" data-sentry-source-file="index.tsx">
            <Styled.AboutSection data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <SubTitle data-sentry-element="SubTitle" data-sentry-source-file="index.tsx">
                    D&D Art Gallery: AI-Generated Characters, NPCs, and Monsters
                </SubTitle>
                <br />
                <Styled.AboutTitle data-sentry-element="unknown" data-sentry-source-file="index.tsx">What is the Gallery?</Styled.AboutTitle>
                <Styled.AboutText data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    Share your creations with the CharGen community and check
                    out what others have been doing in the Gallery section.
                </Styled.AboutText>
                <br></br>
                <Styled.AboutText data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    This is the spot for a dose of inspiration or to find that
                    perfect NPC art for your next D&D session. Every portrait
                    has been conjured up by someone&apos;s imagination, detailed
                    on a character sheet, and brought to life with a touch of
                    creativity. Whether you&apos;re here to find the face of
                    your next Dungeons & Dragons character or to get ideas for
                    your storytelling, take a moment to enjoy these CharGen
                    creations.
                </Styled.AboutText>
                <br></br>
                <Styled.AboutText data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    If you&apos;re piecing together your Dungeons and Dragons
                    world or trying to find that perfect NPC art for your next
                    D&D session, why not see what narratives your fellow players
                    have spun, or better yet, share your own character art with
                    us.
                </Styled.AboutText>
            </Styled.AboutSection>
            <Styled.ImageGalleryWrapper data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <ImageGallery gallerySubtitle="Recent Generations: " userGallery={false} data-sentry-element="ImageGallery" data-sentry-source-file="index.tsx" />
            </Styled.ImageGalleryWrapper>
        </Styled.Main>;
};